/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/
import i18n from "./i18n";
import React from "react";
import { I18nextProvider } from "react-i18next";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store/store";
import ScrollToTop from "./scrollToTop";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import {
  ThemeProvider,
  createTheme,
  CssBaseline,
} from "@mui/material";

// Get root DOM element
const container = document.getElementById("root");

// Create React root
const root = ReactDOM.createRoot(container);

// GLOBAL THEME FIX
const theme = createTheme({
  components: {

    // Prevent scrollbar disappearing (fix page jumping)
    MuiModal: {
      defaultProps: {
        disableScrollLock: true,
      },
    },

    // Also ensure Menu uses same behavior
    MuiPopover: {
      defaultProps: {
        disableScrollLock: true,
      },
    },

    // Ensure Menu component too
    MuiMenu: {
      defaultProps: {
        disableScrollLock: true,
      },
    },

  },
});

// Render app
root.render(
  <I18nextProvider i18n={i18n}>
    <Provider store={store}>
      <DndProvider backend={HTML5Backend}>
        <BrowserRouter>
          <ThemeProvider theme={theme}>

            {/* important: normalize layout and prevent shift */}
            <CssBaseline />

            <ScrollToTop />
            <App />

          </ThemeProvider>
        </BrowserRouter>
      </DndProvider>
    </Provider>
  </I18nextProvider>
);

// Unregister service worker
serviceWorker.unregister();

